import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import MediaCard from '@/components/feature/MediaCard';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import NewsPanel from '@/pages/home/components/NewsPanel';
import FeaturedPanel from '@/pages/home/components/FeaturedPanel';
import { mediaList } from '@/mocks/media';
import { newsList } from '@/mocks/news';
import { aboutContent } from '@/mocks/filters';

const HERO_IDS = ['m-001', 't-001', 'm-004', 'v-003'];

export default function Home() {
  const heroItems = HERO_IDS.map((id) => mediaList.find((m) => m.id === id)).filter((m) => Boolean(m));
  const featuredGrid = [...mediaList].sort((a, b) => b.popularity - a.popularity).slice(0, 8);
  const topRated = [...mediaList].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <div className="w-full">
      <div className="w-full max-w-content mx-auto px-4 md:px-8 py-6 md:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-8 flex flex-col gap-8">
            <HeroCarousel items={heroItems as typeof mediaList} />
            <section>
              <SectionHeading title="最新影视资讯" subtitle="抢先了解剧集动态、幕后花絮与独家专访" moreTo="/search" />
              <NewsPanel items={newsList.slice(0, 6)} />
            </section>
          </div>

          <aside className="lg:col-span-4 flex flex-col gap-8">
            <section>
              <SectionHeading title="分类快捷入口" subtitle="快速进入想看的影视类型" />
              <CategoryShortcuts />
            </section>
            <section>
              <SectionHeading title="精选推荐" subtitle="编辑精选 · 高分口碑" />
              <FeaturedPanel items={topRated} />
            </section>
          </aside>
        </div>
      </div>

      <section className="w-full max-w-content mx-auto px-4 md:px-8 pb-4">
        <SectionHeading title="精选视频推荐" subtitle="热门高分影视，一键直达详情与观看入口" moreTo="/category/movie" />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {featuredGrid.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="w-full max-w-content mx-auto px-4 md:px-8 py-10 md:py-14">
        <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10 grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-2">
            <h1 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">
              蘑菇视频 · 最新影视剧资讯与高清视频观看平台
            </h1>
            <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-4">{aboutContent.intro}</p>
            <p className="text-sm font-medium text-primary-600 mb-6">{aboutContent.mission}</p>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
            <div className="rounded-lg bg-background-50 border border-background-200 p-4 text-center lg:text-left">
              <p className="font-heading font-black text-2xl text-primary-500">{mediaList.length}</p>
              <p className="text-xs text-foreground-500 mt-1">精选影视内容</p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-4 text-center lg:text-left">
              <p className="font-heading font-black text-2xl text-accent-500">3</p>
              <p className="text-xs text-foreground-500 mt-1">电影 · 剧集 · 综艺</p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-4 text-center lg:text-left">
              <p className="font-heading font-black text-2xl text-secondary-600">1080P</p>
              <p className="text-xs text-foreground-500 mt-1">高清观看入口</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}